export enum DentureStyle {
    Basic = 1,
    Standard = 2,
    Pro = 3,
}
